import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import RadioButtons from '../radioButtons/radioButtons';
import imageAndTextTemplate from './imageAndTextTemplate';
var RadioButtonsWithIllustration = function RadioButtonsWithIllustration(_ref) {
  var getClassName = _ref.getClassName,
    automationId = _ref.automationId,
    dataHook = _ref.dataHook,
    value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    selectionArea = _ref.selectionArea;
  return /*#__PURE__*/React.createElement(RadioButtons, {
    className: getClassName('image-and-text-radio-buttons'),
    automationId: automationId,
    dataHook: dataHook,
    value: value,
    onChange: onChange,
    labelTemplate: imageAndTextTemplate,
    options: options,
    selectionArea: selectionArea
  });
};
RadioButtonsWithIllustration.displayName = 'RadioButtonsWithIllustration';
RadioButtonsWithIllustration.propTypes = {
  /** hook for testing purposes */
  dateHook: PropTypes.string,
  /** The value of the selected options */
  value: PropTypes.string.isRequired,
  /** Callback function (options) => {}, triggered on option selection change */
  onChange: PropTypes.func.isRequired,
  /** List of options to display */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    image: PropTypes.element,
    tooltip: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    disabled: PropTypes.bool,
    suffix: PropTypes.element
  })).isRequired,
  /** Controls selection area highlight visibility */
  selectionArea: PropTypes.bool
};
export default compose(RadioButtonsWithIllustration);